/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Verify_Email_Email_RequiredInputs */

const en_common_sign_verify_email_email_required = /** @type {(inputs: Common_Sign_Verify_Email_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email is required`)
};

const zh_common_sign_verify_email_email_required = /** @type {(inputs: Common_Sign_Verify_Email_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱不能为空`)
};

/**
* | output |
* | --- |
* | "Email is required" |
*
* @param {Common_Sign_Verify_Email_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_verify_email_email_required = /** @type {((inputs?: Common_Sign_Verify_Email_Email_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Verify_Email_Email_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_verify_email_email_required(inputs)
	return zh_common_sign_verify_email_email_required(inputs)
});
export { common_sign_verify_email_email_required as "common.sign.verify_email_email_required" }